<template>
  <div class="home-page">
    <main class="home-marketplace">
      <section class="sample-products" v-if="products && productResponse">
        <div class="home-section-heading">
          <div>
            <p class="home-section-kicker">CURATED FOR YOUR DAY</p>
            <h2>Popular products</h2>
          </div>
        </div>
        <ProductsList :products="products" :responce="productResponse" />
      </section>

      <section class="home-content-section testimonials-section">
        <div class="home-section-heading">
          <div>
            <p class="home-section-kicker">SAMPLE TESTIMONIALS</p>
            <h2>Good things, said by shoppers</h2>
          </div>
        </div>
        <div class="testimonial-grid">
          <article class="testimonial-item" v-for="review in testimonials" :key="review.name">
            <div class="testimonial-stars" role="img" aria-label="Rated 5 out of 5 stars">
              <StarIcon v-for="star in 5" :key="star" class="testimonial-star-icon" aria-hidden="true" />
            </div>
            <blockquote>“{{ review.quote }}”</blockquote>
            <div class="testimonial-author">
              <span class="testimonial-avatar">{{ review.name.substring(0, 1) }}</span>
              <div>
                <p>{{ review.name }}</p>
                <span>{{ review.location }}</span>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="home-content-section journal-section">
        <div class="home-section-heading">
          <div>
            <p class="home-section-kicker">SAMPLE BLOG POSTS</p>
            <h2>From the Tubo journal</h2>
          </div>
        </div>
        <div class="journal-grid">
          <article class="journal-item" v-for="post in blogPosts" :key="post.title">
            <div class="journal-image" :class="post.imageStyle">
              <img :src="post.image" :alt="post.imageAlt" loading="lazy" />
            </div>
            <div class="journal-copy">
              <p class="journal-category">{{ post.category }} <span>{{ post.readTime }}</span></p>
              <h3>{{ post.title }}</h3>
              <p class="journal-excerpt">{{ post.excerpt }}</p>
              <span class="journal-read-more">Read article <span aria-hidden="true">&rarr;</span></span>
            </div>
          </article>
        </div>
      </section>

      <section class="home-content-section video-section">
        <div class="home-section-heading">
          <div>
            <p class="home-section-kicker">TUBO IN A MINUTE</p>
            <h2>See how it works</h2>
          </div>
        </div>
        <div class="video-frame">
          <iframe
            src="https://www.youtube-nocookie.com/embed/ysz5S6PUM-U"
            title="Sample video: Big Buck Bunny"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>

    <div class="container p-8 mx-auto mt-10 max-w-7xl" v-if="settings">
      <div class="home-type-grid grid grid-cols-2 gap-4 md:grid-cols-4" v-if="vendors">
        <router-link
          :to="{
            name: 'VendorHome',
            params: { id: vendor.id, slug: vendor.name ? sanitizeTitle(vendor.name) : sanitizeTitle(vendor.slug)},
          }"
          class="home-type-link flex flex-row items-center"
          v-for="vendor in vendors"
          :key="vendor.id"
        >
          <div
            class="home-type-icon flex items-center justify-center w-10 h-10 p-2 rounded-full md:w-16 md:h-16"
            :style="{ 'background-color': vendor.color }"
          >
            <img v-if="vendor" :src="vendor.logo" class="md:w-10 md:h-10" alt="" />
          </div>
          <div class="ml-2">
            <h1 class="text-sm font-bold">{{ vendor.name }}</h1>
            <p class="mt-1 text-xs font-light text-gray-500">
              {{ truncate(vendor.description, 40) }}
            </p>
          </div>
        </router-link>
      </div>
      <section class="seller-promo container mx-auto mt-20 md:max-w-7xl">
        <div class="seller-promo-copy">
            <h1 class="text-base font-extrabold text-black md:text-3xl">
              {{ $t("landingpageJoin") }}
            </h1>
            <p
              class="mt-1 mb-2 text-xs font-light text-gray-500 md:text-sm md:w-96"
            >
              {{ $t("landingpageJoinSubHeader") }}
            </p>
            <a
              :style="{ 'background-color': settings.colors.primaryColor }"
              :href="`${this.$store.state.baseUrl}register/vendor`"
              target="__blank"
              class="flex items-center justify-center h-10 px-2 py-2 mt-5 mb-5 text-xs font-light text-center text-white rounded-full w-30 md:w-44 md:text-base md:h-14"
            >
              {{ $t("landingpageSellerHeader") }}</a
            >
            <hr class="mt-2" />
            <div class="seller-promo-features flex justify-between mt-3">
              <div class="flex">
                <img src="/img/icons/money.svg" class="w-5 h-5" alt="" />
                <div class="ml-2">
                  <h1 class="text-xs font-medium md:text-sm">
                    {{ $t("landingpageSellerFeat1") }}
                  </h1>
                  <p class="text-xs font-light text-gray-500">
                    {{ $t("landingpageSellerFeat3") }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <img
                  src="/img/icons/list.svg"
                  class="w-5 h-5 font-light rotate-180"
                  alt=""
                />
                <div class="ml-2">
                  <h1 class="text-xs font-medium md:text-sm">
                    {{ $t("landingpageSellerFeat2") }}
                  </h1>
                  <p class="text-xs font-light text-gray-500">
                    {{ $t("landingpageSellerFeat4") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img
            src="/img/woman.JPG"
            class="seller-promo-image hidden w-6/12 rounded-r-2xl md:h-80 md:flex"
            alt="Shop owner in her store"
          />
      </section>
    </div>
    </main>
  </div>
</template>
<script>
import axios from "axios";
import ProductsList from "@/components/Default/ProductsList.vue";
import { StarIcon } from "@heroicons/vue/24/outline";
export default {
  name: "HomeView",

  components: {
    ProductsList,
    StarIcon,
  },
  data() {
    return {
      vendors: null,
      products: null,
      productResponse: null,
      testimonials: [
        {
          name: "Diana K.",
          location: "North Ridge",
          quote: "Finding my neighbourhood shops in one place makes the weekly run so much easier.",
        },
        {
          name: "Marcus T.",
          location: "Central District",
          quote: "The order arrived quickly, and I could keep track of everything from checkout to delivery.",
        },
        {
          name: "Amara B.",
          location: "East Park",
          quote: "I love discovering small local businesses I had never come across before.",
        },
        {
          name: "Noah R.",
          location: "Riverside",
          quote: "A clear, simple way to shop for everyday essentials without making extra stops.",
        },
      ],
      blogPosts: [
        {
          category: "LOCAL BUSINESS",
          readTime: "4 min read",
          title: "The people behind your neighbourhood shops",
          excerpt: "Meet the independent sellers making everyday shopping feel more personal.",
          image: "/img/woman.JPG",
          imageAlt: "Independent shop owner in her store",
          imageStyle: "journal-image-photo",
        },
        {
          category: "SMART SHOPPING",
          readTime: "3 min read",
          title: "A thoughtful guide to choosing quality",
          excerpt: "A few practical details can make it easier to find products that suit you.",
          image: "/img/quality.png",
          imageAlt: "Quality guarantee illustration",
          imageStyle: "journal-image-illustration",
        },
        {
          category: "WELLNESS",
          readTime: "5 min read",
          title: "Making pharmacy essentials easier to find",
          excerpt: "Explore convenient ways to browse everyday health and personal-care items.",
          image: "/img/prescription.png",
          imageAlt: "Prescription and medicine illustration",
          imageStyle: "journal-image-illustration",
        },
        {
          category: "DELIVERY",
          readTime: "3 min read",
          title: "Small ways to make delivery day smoother",
          excerpt: "A little planning helps every order fit more naturally into your day.",
          image: "/img/shopping-cart.png",
          imageAlt: "Shopping cart illustration",
          imageStyle: "journal-image-illustration",
        },
      ],
      settings: null,
      // base_url: this.$store.state.baseUrl,
      base_url: this.$store.state.baseUrl,
      search: null,
      types: null,
    };
  },
  mounted() {
    let selectedLanguage = localStorage.getItem("selectedLanguage");
    const headers = {
      lang: selectedLanguage,
    };
    this.$store.commit("loading", true);
    axios
      .get(this.base_url + "api/vendor/types", {headers})
      .then((response) => {
        this.vendors = response.data;
        this.$store.commit("loading", false);
        // console.log(this.vendors)
      })
      .catch((error) => console.log(error));

    axios
      .get(this.base_url + "api/products?page=1", { headers })
      .then((response) => {
        this.products = response.data.data.slice(0, 8);
        this.productResponse = { current_page: 1, last_page: 1 };
      })
      .catch((error) => console.log(error));

    this.$store.dispatch("fetchSettings", this.items).then(() => {
      this.settings = this.$store.state.settings;
      this.currency = this.settings.strings.currency;
      // console.log(this.settings)
    });
  },

  methods: {
    truncate(str, n) {
      return str.length > n ? str.substr(0, n - 1) + "..." : str;
    },

    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>

<style scoped>
.home-page {
  overflow: hidden;
}

.home-marketplace {
  padding-bottom: 1rem;
}

.sample-products {
  max-width: 80rem;
  margin: 2.5rem auto 0;
  padding: 0 1.5rem;
}

.home-content-section {
  max-width: 80rem;
  margin: 3.25rem auto 0;
  padding: 0 1.5rem;
}

.home-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.home-section-kicker {
  margin-bottom: 0.2rem;
  color: var(--color-green);
  font-size: 0.65rem;
  font-weight: 800;
}

.home-section-heading h2 {
  font-size: 1.85rem;
  line-height: 1.15;
}

.sample-products {
  margin-top: 2rem;
}

.sample-products :deep(.container) {
  max-width: none;
  padding-right: 0;
  padding-left: 0;
}

.testimonial-grid,
.journal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.testimonial-item,
.journal-item {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-line);
  border-radius: 0.65rem;
  background: #fff;
}

.testimonial-item {
  display: flex;
  min-height: 14rem;
  flex-direction: column;
  padding: 1.15rem;
}

.testimonial-stars {
  display: flex;
  gap: 0.2rem;
  align-items: center;
  color: var(--color-coral);
}

.testimonial-star-icon {
  width: 0.95rem;
  height: 0.95rem;
  stroke-width: 1.8;
}

.testimonial-item blockquote {
  flex: 1;
  margin: 0.8rem 0 1.2rem;
  color: #405047;
  font-size: 0.85rem;
  line-height: 1.65;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding-top: 0.8rem;
  border-top: 1px solid #edf0eb;
}

.testimonial-avatar {
  display: grid;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  color: var(--color-green-dark);
  background: #e9f0ea;
  font-size: 0.85rem;
  font-weight: 700;
}

.testimonial-author p {
  color: var(--color-ink);
  font-size: 0.75rem;
  font-weight: 700;
}

.testimonial-author span:not(.testimonial-avatar) {
  color: var(--color-muted);
  font-size: 0.68rem;
}

.journal-image {
  display: grid;
  height: 10rem;
  place-items: center;
  overflow: hidden;
  background: #edf3ee;
}

.journal-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.journal-image-illustration img {
  width: 4.5rem;
  height: 4.5rem;
  object-fit: contain;
}

.journal-item:nth-child(2) .journal-image {
  background: #edf3ee;
}

.journal-item:nth-child(3) .journal-image {
  background: #edf3ee;
}

.journal-item:nth-child(4) .journal-image {
  background: #edf3ee;
}

.journal-copy {
  padding: 0.9rem;
}

.journal-category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  color: var(--color-green);
  font-size: 0.6rem;
  font-weight: 700;
}

.journal-category span {
  color: var(--color-muted);
  font-weight: 500;
  white-space: nowrap;
}

.journal-copy h3 {
  margin-top: 0.55rem;
  font-family: var(--font-body);
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.4;
}

.journal-excerpt {
  margin-top: 0.45rem;
  color: var(--color-muted);
  font-size: 0.75rem;
  line-height: 1.55;
}

.journal-read-more {
  display: inline-flex;
  gap: 0.35rem;
  margin-top: 0.8rem;
  color: var(--color-green);
  font-size: 0.72rem;
  font-weight: 700;
}

.video-frame {
  width: min(100%, 58rem);
  aspect-ratio: 16 / 9;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 0.65rem;
  background: #18231d;
}

.video-frame iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.home-type-grid {
  gap: 0.75rem;
}

.home-type-link {
  min-width: 0;
  gap: 0.85rem;
  padding: 0.8rem;
  border: 1px solid var(--color-line);
  border-radius: 0.9rem;
  background: #fff;
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.home-type-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 26px rgba(32, 52, 43, 0.08);
}

.home-type-icon {
  width: 3.3rem;
  height: 3.3rem;
  flex: 0 0 auto;
  border-radius: 0.85rem;
}

.home-type-link h1 {
  overflow: hidden;
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-type-link p {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.45;
}

.seller-promo {
  display: grid;
  min-height: 19rem;
  grid-template-columns: 1fr minmax(17rem, 0.82fr);
  overflow: hidden;
  border-radius: 1rem;
  background: #e8f0e9;
}

.seller-promo-copy {
  padding: 2rem 2.5rem;
}

.seller-promo-copy h1 {
  max-width: 14ch;
  font-size: 2.2rem;
  line-height: 1.15;
}

.seller-promo-copy > a {
  min-width: 11rem;
  border-radius: 0.55rem;
  background: var(--color-green) !important;
  font-weight: 800;
}

.seller-promo-features {
  gap: 1.25rem;
}

.seller-promo-features > div {
  min-width: 0;
}

.seller-promo-image {
  width: 100%;
  height: 100%;
  min-height: 19rem;
  object-fit: cover;
  object-position: center 40%;
}

@media (max-width: 767px) {
  .sample-products,
  .home-content-section {
    margin-top: 1.75rem;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .testimonial-grid,
  .journal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.65rem;
  }

  .home-section-heading h2 {
    font-size: 1.55rem;
  }

  .sample-products :deep(.grid) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.65rem;
  }

  .sample-products :deep(.product-photo) {
    height: 6.5rem;
  }

  .home-type-grid {
    padding: 1.25rem 1rem 0;
  }

  .home-type-link {
    gap: 0.6rem;
    padding: 0.6rem;
  }

  .home-type-icon {
    width: 2.5rem;
    height: 2.5rem;
  }

  .home-type-link h1 {
    font-size: 0.72rem;
  }

  .home-type-link p {
    font-size: 0.65rem;
  }

  .seller-promo {
    display: block;
    margin: 2rem 1rem 0;
  }

  .seller-promo-copy {
    padding: 1.5rem;
  }

  .seller-promo-copy h1 {
    font-size: 1.75rem;
  }

  .seller-promo-features {
    gap: 0.75rem;
  }

}

@media (min-width: 768px) and (max-width: 1050px) {
  .testimonial-grid,
  .journal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
